function Simpleline() {
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title">Simple line icons</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                Icons
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Simple line icons
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Simple line icons</h4>
              <div className="icons-list row">
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-user"></i>icon-user{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-people"></i>icon-people{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-user-female"></i> icon-user-female{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-user-follow"></i> icon-user-follow{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-user-following"></i> icon-user-following{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-user-unfollow"></i> icon-user-unfollow{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-login"></i> icon-login{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-logout"></i> icon-logout{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-emotsmile"></i> icon-emotsmile{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-phone"></i> icon-phone{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-call-end"></i> icon-call-end{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-call-in"></i> icon-call-in{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-call-out"></i> icon-call-out{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-map"></i> icon-map{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-location-pin"></i> icon-location-pin{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-direction"></i> icon-direction{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-directions"></i> icon-directions{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-compass"></i> icon-compass{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-layers"></i> icon-layers{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-menu"></i> icon-menu{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-list"></i> icon-list{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-options-vertical"></i>{" "}
                    icon-options-vertical{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-options"></i> icon-options{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-arrow-down"></i> icon-arrow-down{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-arrow-left"></i> icon-arrow-left{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-arrow-right"></i> icon-arrow-right{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-arrow-up"></i> icon-arrow-up{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-arrow-up-circle"></i>{" "}
                    icon-arrow-up-circle{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-arrow-left-circle"></i>{" "}
                    icon-arrow-left-circle{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-arrow-right-circle"></i>{" "}
                    icon-arrow-right-circle{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-arrow-down-circle"></i>{" "}
                    icon-arrow-down-circle{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-check"></i> icon-check{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-clock"></i> icon-clock{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-plus"></i> icon-plus{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-close"></i> icon-close{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-trophy"></i> icon-trophy{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-screen-smartphone"></i>{" "}
                    icon-screen-smartphone{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-screen-desktop"></i> icon-screen-desktop{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-plane"></i> icon-plane{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-notebook"></i> icon-notebook{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-mustache"></i> icon-mustache{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-mouse"></i> icon-mouse{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-magnet"></i> icon-magnet{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-energy"></i> icon-energy{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-disc"></i> icon-disc{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-cursor"></i> icon-cursor{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-cursor-move"></i> icon-cursor-move{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-crop"></i> icon-crop{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-chemistry"></i> icon-chemistry{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-speedometer"></i> icon-speedometer{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-shield"></i> icon-shield{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-screen-tablet"></i> icon-screen-tablet{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-magic-wand"></i> icon-magic-wand{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-hourglass"></i> icon-hourglass{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-graduation"></i> icon-graduation{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-ghost"></i> icon-ghost{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-game-controller"></i>{" "}
                    icon-game-controller{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-fire"></i> icon-fire{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-eyeglass"></i> icon-eyeglass{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-envelope-open"></i> icon-envelope-open{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-envelope-letter"></i>{" "}
                    icon-envelope-letter{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-bell"></i> icon-bell{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-badge"></i> icon-badge{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-anchor"></i> icon-anchor{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-wallet"></i> icon-wallet{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-vector"></i> icon-vector{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-speech"></i> icon-speech{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-puzzle"></i> icon-puzzle{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-printer"></i> icon-printer{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-present"></i> icon-present{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-playlist"></i> icon-playlist{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-pin"></i> icon-pin{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-picture"></i> icon-picture{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-handbag"></i> icon-handbag{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-globe-alt"></i> icon-globe-alt{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-globe"></i> icon-globe{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-folder-alt"></i> icon-folder-alt{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-folder"></i> icon-folder{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-film"></i> icon-film{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-feed"></i> icon-feed{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-drop"></i> icon-drop{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-drawer"></i> icon-drawer{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-docs"></i> icon-docs{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-doc"></i> icon-doc{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-diamond"></i> icon-diamond{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-cup"></i> icon-cup{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-calculator"></i> icon-calculator{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-bubbles"></i> icon-bubbles{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-briefcase"></i> icon-briefcase{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-book-open"></i> icon-book-open{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-basket-loaded"></i> icon-basket-loaded{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-basket"></i> icon-basket{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-bag"></i> icon-bag{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-action-undo"></i> icon-action-undo{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-action-redo"></i> icon-action-redo{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-wrench"></i> icon-wrench{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-umbrella"></i> icon-umbrella{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-trash"></i> icon-trash{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-tag"></i> icon-tag{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-support"></i> .icon-support{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-frame"></i> icon-frame{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-size-fullscreen"></i>{" "}
                    icon-size-fullscreen{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-size-actual"></i> icon-size-actual{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-shuffle"></i> icon-shuffle{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-share-alt"></i> icon-share-alt{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-share"></i> icon-share{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-rocket"></i> icon-rocket{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-question"></i> icon-question{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-pie-chart"></i> icon-pie-chart{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-pencil"></i> icon-pencil{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-note"></i> icon-note{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-loop"></i> icon-loop{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-home"></i> icon-home{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-grid"></i> icon-grid{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-graph"></i> icon-graph{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-microphone"></i> icon-microphone{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-music-tone-alt"></i> icon-music-tone-alt{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-music-tone"></i> icon-music-tone{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-earphones-alt"></i> icon-earphones-alt{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-earphones"></i> icon-earphones{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-equalizer"></i> icon-equalizer{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-like"></i> icon-like{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-dislike"></i> icon-dislike{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-control-start"></i> icon-control-start{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-control-rewind"></i> icon-control-rewind{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-control-play"></i> icon-control-play{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-control-pause"></i> icon-control-pause{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-control-forward"></i>{" "}
                    icon-control-forward{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-control-end"></i> icon-control-end{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-volume-1"></i> icon-volume-1{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-volume-2"></i> icon-volume-2{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-volume-off"></i> icon-volume-off{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-calendar"></i> icon-calendar{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-bulb"></i> icon-bulb{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-chart"></i> icon-chart{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-ban"></i> icon-ban{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-bubble"></i> icon-bubble{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-camrecorder"></i> icon-camrecorder{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-camera"></i> icon-camera{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-cloud-download"></i> icon-cloud-download{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-cloud-upload"></i> icon-cloud-upload{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-eye"></i> icon-eye{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-flag"></i> icon-flag{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-heart"></i> icon-heart{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-info"></i> icon-info{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-key"></i> icon-key{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-link"></i> icon-link{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-lock"></i> icon-lock{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-lock-open"></i> icon-lock-open{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-magnifier"></i> icon-magnifier{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-magnifier-add"></i> icon-magnifier-add{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-magnifier-remove"></i>{" "}
                    icon-magnifier-remove{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-paper-clip"></i> icon-paper-clip{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-paper-plane"></i> icon-paper-plane{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-power"></i> icon-power{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-refresh"></i> icon-refresh{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-reload"></i> icon-reload{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-settings"></i> icon-settings{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-star"></i> icon-star{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-symbol-female"></i> icon-symbol-female{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-symbol-male"></i> icon-symbol-male{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-target"></i> icon-target{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-credit-card"></i> icon-credit-card{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-paypal"></i> icon-paypal{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-tumblr"></i> icon-social-tumblr{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-twitter"></i> icon-social-twitter{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-facebook"></i>{" "}
                    icon-social-facebook{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-instagram"></i>{" "}
                    icon-social-instagram{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-linkedin"></i>{" "}
                    icon-social-linkedin{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-pinterest"></i>{" "}
                    icon-social-pinterest{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-github"></i> icon-social-github{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-google"></i> icon-social-google{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-reddit"></i> icon-social-reddit{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-skype"></i> icon-social-skype{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-dribbble"></i>{" "}
                    icon-social-dribbble{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-behance"></i> icon-social-behance{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-foursqare"></i>{" "}
                    icon-social-foursqare{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-soundcloud"></i>{" "}
                    icon-social-soundcloud{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-spotify"></i> icon-social-spotify{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-stumbleupon"></i>{" "}
                    icon-social-stumbleupon{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-youtube"></i> icon-social-youtube{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <div className="preview">
                    {" "}
                    <i className="icon-social-dropbox"></i> icon-social-dropbox{" "}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Simpleline;
